module.exports = "../../static/img/fill.5bfd2e2.svg";